import { AgGridTable, type CustomColDef } from '@shared/components/ui/AgGridTable';
import type { Wallet } from '../../models/Wallets';

interface WalletsAgGridTableProps {
  wallets: Wallet[];
  columnDefs: CustomColDef[];
  fetchNextPage?: () => void;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
}

export const WalletsAgGridTable = ({
  wallets,
  columnDefs,
  fetchNextPage,
  hasNextPage = false,
  isFetchingNextPage = false,
}: WalletsAgGridTableProps) => {
  return (
    <AgGridTable
      data={wallets}
      columnDefs={columnDefs}
      height="calc(100vh - 150px)"
      rowHeight={64}
      enableSelection={false}
      suppressAggFuncInHeader={true}
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage}
      isFetchingNextPage={isFetchingNextPage}
    />
  );
};
